
const config = {
  VERSION:  "0.0.1",
  
}   


export default config;
